import { useState } from "react";
import { Text } from "$components";
import JTable from "$components/JTable/JTable";
import { theme } from "$utils/theme/bataillog";
import { columns, data } from "./jTableData";

const rowsPerPage = 10;

function Tables() {
  const [pageIndex, setPageIndex] = useState(0);
  const pageCount = Math.ceil(data.length / rowsPerPage);

  return (
    <>
      <Text type="h3">JTable</Text>
      <Text style={{ marginBottom: theme.spacing(2) }}>
        {rowsPerPage} lignes par page, {pageCount} pages
      </Text>
      <JTable
        data={data.slice(
          pageIndex * rowsPerPage,
          (pageIndex + 1) * rowsPerPage
        )}
        columns={columns}
        setFilter={() => null}
        setPageIndex={setPageIndex}
        pageIndex={pageIndex}
        pageCount={pageCount}
      />
    </>
  );
}

export default Tables;
